import styled from 'styled-components';
import { robotoRegular, scarpaGray200, scarpaGray900, white, electricPurple600, electricPurple100 } from '@habitech/shared';

export const MapWrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
`;

const baseButton = `
  position: absolute;
  z-index: 1000;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  font-family: ${robotoRegular};
`;

export const ResetButton = styled.button`
  ${baseButton}
  top: 20px;
  right: 20px;
  background: ${white};
  border: 1px solid ${scarpaGray200};
  font-weight: 400;
  color: ${scarpaGray900};

  &:hover {
    background: ${scarpaGray200};
  }
`;

export const DownloadButton = styled.button`
  ${baseButton}
  top: 60px;
  right: 20px;
  background: ${electricPurple100};
  border: 1px solid ${electricPurple600};
  font-weight: 600;
  color: ${electricPurple600};

  &:hover {
    background: ${electricPurple600};
    color: ${white};
  }
`;
